import {Component, effect, OnInit} from '@angular/core';

@Component({
    selector: 'app-redirect-animation',
    standalone: true,
    imports: [

    ],
    providers: [
    ],
    templateUrl: './redirect-animation.component.html',
    styleUrl: './redirect-animation.component.scss'
})
export class RedirectAnimationComponent implements OnInit {


    constructor(
    ) {
    }

    ngOnInit(): void {

    }
}
